import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueGtag from "vue-gtag";
import VueResource from 'vue-resource';



import './assets/scss/app.scss'

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import "aos/dist/aos.css";



Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueResource)


let app
app = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

Vue.use(VueGtag, {
    config: { id: "G-53C4PSCB01" }
}, router);